import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        // primary: "#2c398f",
        // secondary: "#26aae0",
        // accent: "#FC6732",
        // error: "#FC6732",
        // success: "#35c2a5",
        // info: "#3D53BF",
        background: "#f2f3f8",
        white: "#ffffff",
        textHeader: "#304156",
      },
    },
  },
});
